import { plugToRequest } from 'react-cookies'

export const CLOUDFRONT_BASE_URL = `https://d3gievmnjacng1.cloudfront.net`
// export const CLOUDFRONT_BASE_URL = `https://maya-b2b.s3.eu-central-1.amazonaws.com`

export const CLIENT_SYSTEM_COLORS = {
  tourtailors: {
    HUE: '#758298',
    MAIN_COLOR: '#f26e21',
    TEXT_COLOR: '#646e80',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#425b76',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#eaf0f6',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#f26e21',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#eaf0f6',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#f26e21',
    SLATE_100: '#646e80',
    SLATE_75: '#646e80',
    SLATE_50: '#646e80',
    SLATE_25: '#646e80',
    CTA_COLOR: '#f26e21',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#eaf0f6',
    BORDER_75: '#eaf0f6',
    BORDER_50: '#eaf0f6',
    BORDER_25: '#eaf0f6',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#646e80',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#f26e21',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#f26e21',
    CARD_LABEL_COLOR: '#f26e21',
  },
  lifexperiences: {
    HUE: '#758298',
    MAIN_COLOR: '#ee8e06',
    TEXT_COLOR: '#414141',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#414141',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#f3f3f3',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#ee8e06',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#f3f3f3',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#f1f1f1',
    SLATE_100: '#414141',
    SLATE_75: '#414141',
    SLATE_50: '#414141',
    SLATE_25: '#414141',
    CTA_COLOR: '#ee8e06',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#414141',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#f1f1f1',
    LABEL_IMAGE_BACKGROUND_COLOR: '#ee8e06',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#ee8e06',
    CARD_LABEL_COLOR: '#ee8e06',
  },
  flytrip: {
    HUE: '#758298',
    MAIN_COLOR: '#0aad01',
    TEXT_COLOR: '#121519',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#121519',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#0aad01',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#0aad01',
    SLATE_100: '#576071',
    SLATE_75: '#576071',
    SLATE_50: '#576071',
    SLATE_25: '#576071',
    CTA_COLOR: '#0aad01',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#110A6A',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#110A6A',
    CARD_LABEL_COLOR: '#110A6A',
  },
  maya: {
    HUE: '#758298',
    MAIN_COLOR: '#7B68F9',
    TEXT_COLOR: '#2b2b2b',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2b2b2b',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#7B68F9',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#7B68F9',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#2b2b2b',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#a5d4c5',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#a5d4c5',
    CARD_LABEL_COLOR: '#a5d4c5',
  },
  bestarctic: {
    HUE: '#758298',
    MAIN_COLOR: '#50A0A0',
    TEXT_COLOR: '#295151',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#FFF',
    USER_TEXT_MESSAGE_COLOR: '#000000',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#50A0A0',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#50A0A0',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#50A0A0',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#295151',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#50A0A0',
    LABEL_IMAGE_BACKGROUND_COLOR: '#a5d4c5',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#a5d4c5',
    CARD_LABEL_COLOR: '#a5d4c5',
  },
  holapola: {
    HUE: '#758298',
    MAIN_COLOR: '#88362F',
    TEXT_COLOR: '#2b2b2b',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2b2b2b',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#88362F',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#88362F',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#2b2b2b',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#F5F0E1',
    LABEL_IMAGE_BACKGROUND_COLOR: '#88362F',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#88362F',
    CARD_LABEL_COLOR: '#88362F',
  },
  plugplugtravel: {
    HUE: '#758298',
    MAIN_COLOR: '#31596a',
    TEXT_COLOR: '#2b2b2b',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2b2b2b',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#31596a',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#31596a',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#2b2b2b',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#a5d4c5',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#a5d4c5',
    CARD_LABEL_COLOR: '#a5d4c5',
  },
  zoover: {
    HUE: '#758298',
    MAIN_COLOR: '#ff6f26',
    TEXT_COLOR: '#3A3A3A',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#3A3A3A',
    USER_TEXT_MESSAGE_COLOR: '#3A3A3A',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FBFBFB',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFE2D4',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#FBFBFB',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#FFE2D4',
    SLATE_100: '#3A3A3A',
    SLATE_75: '#808080',
    SLATE_50: '#808080',
    SLATE_25: '#808080',
    CTA_COLOR: '#ff6f26',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#c9c9c9',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FBFBFB',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#1e1e1e',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#ff6f26',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#ff6f26',
    CARD_LABEL_COLOR: '#669fb2',
  },
  neckermann: {
    HUE: '#758298',
    MAIN_COLOR: '#660184',
    TEXT_COLOR: '#333',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#333',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#660184',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#c9c9c9',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#c9c9c9',
    SLATE_100: '#4e4351',
    SLATE_75: '#4e4351',
    SLATE_50: '#4e4351',
    SLATE_25: '#4e4351',
    CTA_COLOR: '#660184',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#c9c9c9',
    BORDER_75: '#c9c9c9',
    BORDER_50: '#c9c9c9',
    BORDER_25: '#c9c9c9',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#4e4351',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#660184',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#660184',
    CARD_LABEL_COLOR: '#660184',
  },
  bunkhouse: {
    HUE: '#758298',
    MAIN_COLOR: '#FE875E',
    TEXT_COLOR: '#FE875E',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2B2B2B',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#FE875E',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#FE875E',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#FE875E',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#FE875E',
    CARD_LABEL_COLOR: '#FE875E',
  },
  emaar: {
    HUE: '#758298',
    MAIN_COLOR: '#061c35',
    TEXT_COLOR: '#061c35',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#061c35',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#3d69d4',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#3d69d4',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#061c35',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#3d69d4',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#3d69d4',
    CARD_LABEL_COLOR: '#061c35',
  },
  travelbase: {
    HUE: '#758298',
    MAIN_COLOR: '#3E6255',
    TEXT_COLOR: '#1B362C',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#1B362C',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#3E6255',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#98A7A1',
    SLATE_75: '#98A7A1',
    SLATE_50: '#98A7A1',
    SLATE_25: '#98A7A1',
    CTA_COLOR: '#3E6255',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#1B362C',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#98A7A1',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#98A7A1',
    CARD_LABEL_COLOR: '#98A7A1',
  },
  joker: {
    HUE: '#758298',
    MAIN_COLOR: '#d4592b',
    TEXT_COLOR: '#2e6e3a',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#3c3c3c',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#d4592b',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#d4592b',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#3c3c3c',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#FFF',
    LABEL_IMAGE_TEXT_COLOR: '#3c3c3c',
    CARD_ICONS_COLOR: '#fc6b43',
    CARD_LABEL_COLOR: '#2e6e3a',
  },
  frenchmorning: {
    HUE: '#758298',
    MAIN_COLOR: '#d23f39',
    TEXT_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#d23f39',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#d23f39',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#d23f39',
    CARD_LABEL_COLOR: '#d23f39',
  },
  frenchmorningcanada: {
    HUE: '#758298',
    MAIN_COLOR: '#d23f39',
    TEXT_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#606060',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#d23f39',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#d23f39',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#d23f39',
    CARD_LABEL_COLOR: '#d23f39',
  },
  frenchmorninglondon: {
    HUE: '#758298',
    MAIN_COLOR: '#d23f39',
    TEXT_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#606060',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#606060',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#d23f39',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#d23f39',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#d23f39',
    CARD_LABEL_COLOR: '#d23f39',
  },
  wikicampers: {
    HUE: '#758298',
    MAIN_COLOR: '#D4683E',
    TEXT_COLOR: '#212529',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#192f54',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#D4683E',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#D4683E',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#D4683E',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#D4683E',
    CARD_LABEL_COLOR: '#212529',
  },
  isbjorn: {
    HUE: '#758298',
    MAIN_COLOR: '#000000',
    TEXT_COLOR: '#000000',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#000000',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#000000',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#1d9963',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#000000CC',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#000000CC',
    CARD_LABEL_COLOR: '#000000CC',
  },
  tripandstuff: {
    HUE: '#758298',
    MAIN_COLOR: '#2d2d2d',
    TEXT_COLOR: '#2d2d2d',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2d2d2d',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#2d2d2d',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#006ce0',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#000000CC',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#000000CC',
    CARD_LABEL_COLOR: '#000000CC',
  },
  haystravel: {
    HUE: '#758298',
    MAIN_COLOR: '#00437a',
    TEXT_COLOR: '#00437a',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#00437a',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#00437a',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#FBBB00',
    CTA_TEXT_COLOR: '#00437a',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#00437a',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#00437a',
    CARD_LABEL_COLOR: '#00437a',
  },
  dawsonandsanderson: {
    HUE: '#758298',
    MAIN_COLOR: '#669fb2',
    TEXT_COLOR: '#669fb2',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#192f54',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#fc6b43',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#fc6b43',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#fc6b43',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#fc6b43',
    CARD_LABEL_COLOR: '#669fb2',
  },
  nazar: {
    HUE: '#758298',
    MAIN_COLOR: '#669fb2',
    TEXT_COLOR: '#669fb2',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#192f54',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#fc6b43',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#fc6b43',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#fc6b43',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#fc6b43',
    CARD_LABEL_COLOR: '#669fb2',
  },
  aktiefski: {
    HUE: '#758298',
    MAIN_COLOR: '#565656',
    TEXT_COLOR: '#565656',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#565656',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#706f6f',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#565656',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#706f6f',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#706f6f',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#706f6f',
    CARD_LABEL_COLOR: '#706f6f',
  },
  laplandtravel: {
    HUE: '#758298',
    MAIN_COLOR: '#1f1f42',
    TEXT_COLOR: '#0a0a15',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#0a0a15',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#1f1f42',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#1f1f42',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#1f1f42',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#1f1f42',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#1f1f42',
    CARD_LABEL_COLOR: '#1f1f42',
  },
  thegreenprogram: {
    HUE: '#758298',
    MAIN_COLOR: '#21d396',
    TEXT_COLOR: '#2f3151',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2f3151',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#2f3151',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#A6ADA9',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#A6ADA9',
    SLATE_100: '#A6ADA9',
    SLATE_75: '#A6ADA9BF',
    SLATE_50: '#A6ADA980',
    SLATE_25: '#A6ADA940',
    CTA_COLOR: '#21d396',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#A6ADA9',
    BORDER_75: '#A6ADA9BF',
    BORDER_50: '#A6ADA940',
    BORDER_25: '#A6ADA940',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#45476A',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#F8F8F6',
    LABEL_IMAGE_BACKGROUND_COLOR: '#21d396',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#21d396',
    CARD_LABEL_COLOR: '#21d396',
  },
  demo: {
    HUE: '#758298',
    MAIN_COLOR: '#669fb2',
    TEXT_COLOR: '#669fb2',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#192f54',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#fc6b43',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#fc6b43',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#fc6b43',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#fc6b43',
    CARD_LABEL_COLOR: '#669fb2',
  },
  frenchly: {
    HUE: '#758298',
    MAIN_COLOR: '#2F5785',
    TEXT_COLOR: '#2F5785',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2F5785',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#2F5785',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#2F5785',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#2F5785',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#2F5785',
    CARD_LABEL_COLOR: '#2F5785',
  },
  zuiderhuis: {
    HUE: '#758298',
    MAIN_COLOR: '#312220',
    TEXT_COLOR: '#312220',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#312220',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#312220',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#312220',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: 'rgba(49,34,32,.75)',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#9D5C2C',
    CARD_LABEL_COLOR: '#312220',
  },
  levelovoyageur: {
    HUE: '#758298',
    MAIN_COLOR: '#A2BA0A',
    TEXT_COLOR: '#517071',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#707171',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#707171',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#A2BA0A',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#707171',
    MAIN_BACKGROUND_COLOR: '#f5f1eb',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#F07F3C',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#517071',
    CARD_LABEL_COLOR: '#A2BA0A',
  },
  noorderhuis: {
    HUE: '#758298',
    MAIN_COLOR: '#2F5170',
    TEXT_COLOR: '#2F5170',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2F5170',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#2F5170',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#2F5170',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#2F5170',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#2F5170',
    CARD_LABEL_COLOR: '#2F5170',
  },
  kingfisher: {
    HUE: '#758298',
    MAIN_COLOR: '#2297a7',
    TEXT_COLOR: '#242424',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#2F5170',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#2297a7',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#5c5c5c',
    SLATE_75: '#807e7e',
    SLATE_50: '#a6a2a2',
    SLATE_25: '#b5b1b1',
    CTA_COLOR: '#feb950',
    CTA_TEXT_COLOR: '#FFF',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#000000',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#2297a7',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#242424',
    CARD_LABEL_COLOR: '#2297a7',
  },
  odysseus: {
    HUE: '#758298',
    MAIN_COLOR: '#333',
    TEXT_COLOR: '#333',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#858282',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#858282',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#fee344',
    CTA_TEXT_COLOR: '#3a3621',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#666',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#333',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#333',
    CARD_LABEL_COLOR: '#333',
  },
  odysseus_b2b: {
    HUE: '#758298',
    MAIN_COLOR: '#333',
    TEXT_COLOR: '#333',
    ASSISTANT_TEXT_MESSAGE_COLOR: '#858282',
    USER_TEXT_MESSAGE_COLOR: '#FFF',
    ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR: '#FFF',
    USER_TEXT_MESSAGE_BACKGROUND_COLOR: '#858282',
    ASSISTANT_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    USER_TEXT_MESSAGE_BORDER_COLOR: '#bfbdbd',
    SLATE_100: '#595858',
    SLATE_75: '#717171',
    SLATE_50: '#858282',
    SLATE_25: '#a3a2a2',
    CTA_COLOR: '#fee344',
    CTA_TEXT_COLOR: '#3a3621',
    BORDER_100: '#bfbdbd',
    BORDER_75: '#CFCFCF',
    BORDER_50: '#ded9d9',
    BORDER_25: '#ede8e8',
    PAPER_75: '#CDD5E1',
    PAPER_50: '#E6EAF0',
    PAPER_25: '#F3F4F7',
    PAPER_00: '#FFF',
    ERROR: '#E41C1C',
    TITLE_COLOR: '#666',
    MAIN_BACKGROUND_COLOR: '#FFF',
    SEARCH_RESPONSE_BACKGROUND_COLOR: '#EBEBEB',
    LABEL_IMAGE_BACKGROUND_COLOR: '#333',
    LABEL_IMAGE_TEXT_COLOR: '#FFF',
    CARD_ICONS_COLOR: '#333',
    CARD_LABEL_COLOR: '#333',
  },
}

export const CLIENT_STYLINGS = {
  tourtailors: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/tourtailors/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#425b76',
      PRIMARY: '#f26e21',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#eaf0f6',
      SECONDARY_FOREGROUND: '#425b76',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#eaf0f6',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['tourtailors'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['tourtailors'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['tourtailors'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['tourtailors'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['tourtailors'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['tourtailors'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['tourtailors'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['tourtailors'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['tourtailors'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['tourtailors'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['tourtailors'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['tourtailors'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['tourtailors'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['tourtailors'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['tourtailors'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['tourtailors'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['tourtailors'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['tourtailors'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Montserrat, sans-serif',
      PRIMARY: '"Open Sans", sans-serif',
    },
  },
  lifexperiences: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/lifexperiences/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#ee8e06',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['lifexperiences'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['lifexperiences'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['lifexperiences'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['lifexperiences'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['lifexperiences'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['lifexperiences'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['lifexperiences'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['lifexperiences'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['lifexperiences'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['lifexperiences'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['lifexperiences'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['lifexperiences'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['lifexperiences'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['lifexperiences'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['lifexperiences'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['lifexperiences'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['lifexperiences'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['lifexperiences'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Montserrat", sans-serif',
      PRIMARY: '"Atlassian Sans", sans-serif',
    },
  },
  flytrip: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/flytrip/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'capitalize',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#0aad01',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['flytrip'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['flytrip'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['flytrip'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['flytrip'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['flytrip'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['flytrip'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['flytrip'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['flytrip'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['flytrip'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['flytrip'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['flytrip'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['flytrip'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['flytrip'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['flytrip'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['flytrip'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['flytrip'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['flytrip'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['flytrip'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: "'Inter', sans-serif",
      PRIMARY: "'Inter', sans-serif",
    },
  },
  maya: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/maya/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#7B68F9',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['maya'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['maya'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['maya'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['maya'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['maya'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['maya'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['maya'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['maya'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['maya'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['maya'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['maya'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['maya'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['maya'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['maya'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['maya'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['maya'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['maya'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['maya'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['maya'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['maya'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['maya'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR: CLIENT_SYSTEM_COLORS['maya'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['maya'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['maya'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['maya'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"PT Sans", sans-serif',
      PRIMARY: '"PT Sans", sans-serif',
    },
  },
  bestarctic: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bestarctic/images/MayaAvatar.jpg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#4FA0A0',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['bestarctic'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['bestarctic'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['bestarctic'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['bestarctic'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['bestarctic'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['bestarctic'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['bestarctic'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['bestarctic'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['bestarctic'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['bestarctic'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['bestarctic'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['bestarctic'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['bestarctic'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['bestarctic'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['bestarctic'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['bestarctic'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['bestarctic'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['bestarctic'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Asap", sans-serif',
      PRIMARY: '"Asap", sans-serif',
    },
  },
  holapola: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/holapola/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#88362F',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['holapola'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['holapola'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['holapola'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['holapola'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['holapola'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['holapola']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['holapola'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['holapola'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['holapola'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['holapola'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['holapola'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['holapola'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['holapola'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['holapola'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['holapola'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['holapola'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['holapola'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['holapola'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['holapola'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['holapola'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['holapola'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['holapola'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['holapola'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['holapola'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['holapola'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Carlito", sans-serif',
      PRIMARY: '"Carlito", sans-serif',
    },
  },
  plugplugtravel: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/plugplugtravel/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#31596a',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['plugplugtravel'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['plugplugtravel'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['plugplugtravel'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['plugplugtravel'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['plugplugtravel'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['plugplugtravel'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['plugplugtravel'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['plugplugtravel'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['plugplugtravel'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['plugplugtravel'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['plugplugtravel'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['plugplugtravel'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['plugplugtravel'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['plugplugtravel'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['plugplugtravel'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['plugplugtravel'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['plugplugtravel'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['plugplugtravel'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Poppins", sans-serif',
      PRIMARY: '"Poppins", sans-serif',
    },
  },
  zoover: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zoover/images/MayaAvatar.png`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zoover/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '70px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '70px',
    POPOVER_AVATAR_WIDTH_MOBILE: '60px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_BOTTOM_DISTANCE: '45px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'capitalize',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#ff6f26',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['zoover'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['zoover'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['zoover'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['zoover'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['zoover'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['zoover'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['zoover'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['zoover'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['zoover'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['zoover'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['zoover'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['zoover'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['zoover'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['zoover'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['zoover'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['zoover'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['zoover'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['zoover'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['zoover'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['zoover'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['zoover'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['zoover'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['zoover'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['zoover'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Averta", sans-serif',
      PRIMARY: '"Averta", sans-serif',
    },
  },
  neckermann: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/neckermann/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#660184',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['neckermann'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['neckermann'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['neckermann'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['neckermann'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['neckermann'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['neckermann'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['neckermann'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['neckermann'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['neckermann'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['neckermann'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['neckermann'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['neckermann'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['neckermann'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['neckermann'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['neckermann'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['neckermann'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['neckermann'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['neckermann'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Raleway", "Mulish"',
      PRIMARY: '"Raleway", "Mulish"',
    },
  },
  bunkhouse: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bunkhouse/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#FE875E',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['bunkhouse'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['bunkhouse'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['bunkhouse'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['bunkhouse'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['bunkhouse'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['bunkhouse'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['bunkhouse'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['bunkhouse'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['bunkhouse'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['bunkhouse'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['bunkhouse'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['bunkhouse'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['bunkhouse'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['bunkhouse'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['bunkhouse'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['bunkhouse'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['bunkhouse'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['bunkhouse'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Aktiv",sans-serif',
      PRIMARY: '"Aktiv",sans-serif',
    },
  },
  emaar: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/emaar/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#061c35',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['emaar'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['emaar'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['emaar'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['emaar'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['emaar'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['emaar'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['emaar'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['emaar'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['emaar'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['emaar'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['emaar'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['emaar'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['emaar'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['emaar'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['emaar'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['emaar'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['emaar'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['emaar'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['emaar'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['emaar'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['emaar'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['emaar'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['emaar'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['emaar'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Ubuntu", sans-serif',
      PRIMARY: '"Ubuntu", sans-serif',
    },
  },
  travelbase: {
    POPOVER_MOBILE_HEIGHT: '400px',
    POPOVER_DESKTOP_HEIGHT: '400px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/travelbase/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/travelbase/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'none',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#3E6255',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['travelbase'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['travelbase'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['travelbase'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['travelbase'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['travelbase'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['travelbase'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['travelbase'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['travelbase'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['travelbase'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['travelbase'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['travelbase'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['travelbase'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['travelbase'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['travelbase'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['travelbase'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['travelbase'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['travelbase'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['travelbase'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"sofia-pro",sans-serif',
      PRIMARY: '"filson-pro",sans-serif',
    },
  },
  joker: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/joker/images/MayaAvatar.png`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/joker/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d4592b',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['joker'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['joker'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['joker'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['joker'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['joker'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['joker'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['joker'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['joker'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['joker'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['joker'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['joker'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['joker'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['joker'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['joker'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['joker'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['joker'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['joker'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['joker'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['joker'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['joker'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['joker'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['joker'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['joker'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['joker'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"museo slab", sans-serif',
      PRIMARY: '"museo sans", sans-serif',
    },
  },
  frenchmorning: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorning/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorning/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['frenchmorning'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['frenchmorning'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['frenchmorning'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['frenchmorning'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['frenchmorning'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['frenchmorning'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['frenchmorning'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['frenchmorning'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['frenchmorning'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['frenchmorning'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['frenchmorning'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['frenchmorning'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['frenchmorning'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['frenchmorning'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['frenchmorning'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['frenchmorning'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorning'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['frenchmorning'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  frenchmorningcanada: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorningcanada/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorningcanada/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].CTA_COLOR,
      CTA_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['frenchmorningcanada'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada']
          .LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorningcanada'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  frenchmorninglondon: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorninglondon/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorninglondon/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].CTA_COLOR,
      CTA_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['frenchmorninglondon'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon']
          .LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR:
        CLIENT_SYSTEM_COLORS['frenchmorninglondon'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  wikicampers: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/wikicampers/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#D4683E',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['wikicampers'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['wikicampers'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['wikicampers'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['wikicampers'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['wikicampers'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['wikicampers'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['wikicampers'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['wikicampers'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['wikicampers'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['wikicampers'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['wikicampers'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['wikicampers'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['wikicampers'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['wikicampers'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['wikicampers'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['wikicampers'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['wikicampers'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['wikicampers'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'sans-serif',
      PRIMARY: 'sans-serif',
    },
  },
  isbjorn: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/isbjorn/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#000000',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['isbjorn'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['isbjorn'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['isbjorn'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['isbjorn'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['isbjorn'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['isbjorn'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['isbjorn'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['isbjorn'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['isbjorn'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['isbjorn'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['isbjorn'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['isbjorn'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['isbjorn'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['isbjorn'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['isbjorn'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['isbjorn'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['isbjorn'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['isbjorn'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"DIN Pro", sans-serif',
      PRIMARY: '"DIN Pro", sans-serif',
    },
  },
  tripandstuff: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/tripandstuff/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2d2d2d',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['tripandstuff'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['tripandstuff'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['tripandstuff'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['tripandstuff'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['tripandstuff'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['tripandstuff'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['tripandstuff'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['tripandstuff'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['tripandstuff'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['tripandstuff'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['tripandstuff'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['tripandstuff'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['tripandstuff'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['tripandstuff'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['tripandstuff'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['tripandstuff'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['tripandstuff'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['tripandstuff'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Poppins", sans-serif',
      PRIMARY: '"Poppins", sans-serif',
    },
  },
  haystravel: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/haystravel/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#00437a',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['haystravel'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['haystravel'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['haystravel'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['haystravel'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['haystravel'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['haystravel'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['haystravel'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['haystravel'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['haystravel'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['haystravel'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['haystravel'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['haystravel'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['haystravel'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['haystravel'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['haystravel'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['haystravel'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['haystravel'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['haystravel'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: "'Open Sans'",
      PRIMARY: "'Open Sans'",
    },
  },
  dawsonandsanderson: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/dawsonandsanderson/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson']
          .USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['dawsonandsanderson'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson']
          .SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR:
        CLIENT_SYSTEM_COLORS['dawsonandsanderson'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  nazar: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/nazar/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['nazar'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['nazar'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['nazar'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['nazar'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['nazar'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['nazar'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['nazar'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['nazar'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['nazar'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['nazar'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['nazar'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['nazar'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['nazar'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['nazar'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['nazar'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['nazar'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['nazar'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['nazar'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['nazar'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['nazar'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['nazar'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['nazar'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['nazar'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['nazar'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  aktiefski: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/aktiefski/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#565656',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['aktiefski'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['aktiefski'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['aktiefski'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['aktiefski'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['aktiefski'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['aktiefski'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['aktiefski'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['aktiefski'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['aktiefski'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['aktiefski'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['aktiefski'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['aktiefski'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['aktiefski'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['aktiefski'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['aktiefski'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['aktiefski'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['aktiefski'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['aktiefski'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Open Sans',
      PRIMARY: 'Open Sans',
    },
  },
  laplandtravel: {
    POPOVER_MOBILE_HEIGHT: '600px',
    POPOVER_DESKTOP_HEIGHT: '600px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#1f1f42',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['laplandtravel'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['laplandtravel'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['laplandtravel'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['laplandtravel'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['laplandtravel'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['laplandtravel'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['laplandtravel'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['laplandtravel'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['laplandtravel'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['laplandtravel'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['laplandtravel'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['laplandtravel'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['laplandtravel'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['laplandtravel'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['laplandtravel'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['laplandtravel'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['laplandtravel'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['laplandtravel'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"sofia-pro",sans-serif',
      PRIMARY: '"sofia-pro",sans-serif',
    },
  },
  thegreenprogram: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/thegreenprogram/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#21d396',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['thegreenprogram'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['thegreenprogram'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['thegreenprogram'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['thegreenprogram'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['thegreenprogram'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['thegreenprogram'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['thegreenprogram'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['thegreenprogram'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['thegreenprogram'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['thegreenprogram'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['thegreenprogram'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['thegreenprogram'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['thegreenprogram'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['thegreenprogram'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['thegreenprogram'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['thegreenprogram'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['thegreenprogram'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['thegreenprogram'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['thegreenprogram'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['thegreenprogram'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['thegreenprogram'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram']
          .SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR:
        CLIENT_SYSTEM_COLORS['thegreenprogram'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Outfit",sans-serif',
      PRIMARY: '"Outfit",sans-serif',
    },
  },
  frenchly: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchly/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchly/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: true,
    POPOVER_AVATAR_WIDTH_DESKTOP: '200px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '250px',
    POPOVER_AVATAR_WIDTH_MOBILE: '100px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '125px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2F5785',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['frenchly'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['frenchly'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['frenchly'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['frenchly'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['frenchly'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['frenchly'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['frenchly'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['frenchly'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['frenchly'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['frenchly'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['frenchly'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['frenchly'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['frenchly'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['frenchly'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['frenchly'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['frenchly'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['frenchly'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['frenchly'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Canela"',
      PRIMARY: '"VisbyCF-Regular"',
    },
  },
  demo: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/demo/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['demo'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['demo'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['demo'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['demo'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['demo'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['demo'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['demo'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['demo'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['demo'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['demo'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['demo'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['demo'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['demo'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['demo'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['demo'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['demo'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['demo'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['demo'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['demo'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['demo'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['demo'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR: CLIENT_SYSTEM_COLORS['demo'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['demo'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['demo'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['demo'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  zuiderhuis: {
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zuiderhuis/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#312220',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['zuiderhuis'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['zuiderhuis'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['zuiderhuis'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['zuiderhuis'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['zuiderhuis'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['zuiderhuis'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['zuiderhuis'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['zuiderhuis'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['zuiderhuis'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['zuiderhuis'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['zuiderhuis'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['zuiderhuis'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['zuiderhuis'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['zuiderhuis'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['zuiderhuis'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['zuiderhuis'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['zuiderhuis'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['zuiderhuis'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Source Sans Pro',
      PRIMARY: `Spectral, sans-serif`,
    },
  },
  levelovoyageur: {
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/levelovoyageur/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/levelovoyageur/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#A2BA0A',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['levelovoyageur'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['levelovoyageur'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['levelovoyageur'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur']
          .USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['levelovoyageur'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['levelovoyageur'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['levelovoyageur'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['levelovoyageur'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['levelovoyageur'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['levelovoyageur'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['levelovoyageur'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['levelovoyageur'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['levelovoyageur'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['levelovoyageur'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['levelovoyageur'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['levelovoyageur'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['levelovoyageur'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['levelovoyageur'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['levelovoyageur'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Arial, Helvetica, sans-serif',
      PRIMARY: 'Helvetica',
    },
  },
  noorderhuis: {
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/noorderhuis/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/noorderhuis/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2F5170',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['noorderhuis'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['noorderhuis'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['noorderhuis'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['noorderhuis'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['noorderhuis'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['noorderhuis'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['noorderhuis'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['noorderhuis'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['noorderhuis'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['noorderhuis'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['noorderhuis'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['noorderhuis'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['noorderhuis'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['noorderhuis'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['noorderhuis'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['noorderhuis'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['noorderhuis'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Mulish',
      PRIMARY: 'Source Sans Pro',
    },
  },
  kingfisher: {
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/kingfisher/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/kingfisher/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2297a7',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['kingfisher'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['kingfisher'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['kingfisher'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['noorderhuis'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['kingfisher'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['kingfisher'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['kingfisher'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['kingfisher'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['kingfisher'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['kingfisher'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['kingfisher'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['kingfisher'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['kingfisher'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['kingfisher'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['kingfisher'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['kingfisher'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['kingfisher'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['kingfisher'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['kingfisher'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: `'Lato', sans-serif`,
      PRIMARY: `'Lato', sans-serif`,
    },
  },
  odysseus: {
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/odysseus/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/odysseus/images/MayaAvatar.jpg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#333',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['odysseus'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['odysseus'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['odysseus'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['odysseus'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['odysseus'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['odysseus'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['odysseus'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['odysseus'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['odysseus'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['odysseus'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['odysseus'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['odysseus'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['odysseus'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['odysseus'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['odysseus'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['odysseus'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['odysseus'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Alegreya Sans SC',
      PRIMARY: 'Alegreya Sans SC',
    },
  },
  odysseus_b2b: {
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/odysseus_b2b/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/odysseus_b2b/images/MayaAvatar.jpg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: false,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#333',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      ICON_ACTIVE: CLIENT_SYSTEM_COLORS['odysseus_b2b'].MAIN_COLOR,
      ICON_INACTIVE: CLIENT_SYSTEM_COLORS['odysseus_b2b'].PAPER_75,
      GREY_DESCRIPTION: CLIENT_SYSTEM_COLORS['odysseus_b2b'].HUE,
      MAIN_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].MAIN_COLOR,
      TEXT_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].TEXT_COLOR,
      ASSISTANT_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].ASSISTANT_TEXT_MESSAGE_COLOR,
      USER_TEXT_MESSAGE_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].USER_TEXT_MESSAGE_COLOR,
      ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b']
          .ASSISTANT_TEXT_MESSAGE_BACKGROUND_COLOR,
      USER_TEXT_MESSAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].USER_TEXT_MESSAGE_BACKGROUND_COLOR,
      ASSISTANT_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b']
          .ASSISTANT_TEXT_MESSAGE_BORDER_COLOR,
      USER_TEXT_MESSAGE_BORDER_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].USER_TEXT_MESSAGE_BORDER_COLOR,
      CTA_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].CTA_COLOR,
      CTA_TEXT_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].CTA_TEXT_COLOR,
      BORDER_100: CLIENT_SYSTEM_COLORS['odysseus_b2b'].BORDER_100,
      BORDER_75: CLIENT_SYSTEM_COLORS['odysseus_b2b'].BORDER_75,
      BORDER_50: CLIENT_SYSTEM_COLORS['odysseus_b2b'].BORDER_50,
      BORDER_25: CLIENT_SYSTEM_COLORS['odysseus_b2b'].BORDER_25,
      PAPER_75: CLIENT_SYSTEM_COLORS['odysseus_b2b'].PAPER_75,
      PAPER_50: CLIENT_SYSTEM_COLORS['odysseus_b2b'].PAPER_50,
      PAPER_25: CLIENT_SYSTEM_COLORS['odysseus_b2b'].PAPER_25,
      PAPER_00: CLIENT_SYSTEM_COLORS['odysseus_b2b'].PAPER_00,
      SLATE_100: CLIENT_SYSTEM_COLORS['odysseus_b2b'].SLATE_100,
      SLATE_75: CLIENT_SYSTEM_COLORS['odysseus_b2b'].SLATE_75,
      SLATE_50: CLIENT_SYSTEM_COLORS['odysseus_b2b'].SLATE_50,
      SLATE_25: CLIENT_SYSTEM_COLORS['odysseus_b2b'].SLATE_25,
      ERROR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].ERROR,
      TITLE_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].TITLE_COLOR,
      MAIN_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].MAIN_BACKGROUND_COLOR,
      SEARCH_RESPONSE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].SEARCH_RESPONSE_BACKGROUND_COLOR,
      LABEL_IMAGE_BACKGROUND_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].LABEL_IMAGE_BACKGROUND_COLOR,
      LABEL_IMAGE_TEXT_COLOR:
        CLIENT_SYSTEM_COLORS['odysseus_b2b'].LABEL_IMAGE_TEXT_COLOR,
      CARD_ICONS_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].CARD_ICONS_COLOR,
      CARD_LABEL_COLOR: CLIENT_SYSTEM_COLORS['odysseus_b2b'].CARD_LABEL_COLOR,
    },
    FONTS: {
      SECONDARY: 'Alegreya Sans SC',
      PRIMARY: 'Alegreya Sans SC',
    },
  },
}

export const FONT_WEIGHT = {
  LIGHT: '300',
  NORMAL: '400',
  SEMIBOLD: '600',
  BOLD: '700',
}

export const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '575px',
  tablet: '768px',
  laptop: '1025px',
  laptopL: '1440px',
  desktop: '2560px',
}

export const BannerActivitySize = {
  mobile: '334px',
  desktop: '200px',
  desktopInPixels: 200,
}
